module.exports = "https://assets.pclncdn.com/web/next-landing/b8f04f44e5/_next/static/images/hotel-image-2x-fc0bd41826c469f5201dab630a4d3b9b.jpg";